/**
 * [1] Bussiness
 * [2] HTTP
 */

/**
 *
 * Bussiness
 *
 */
export const GRANDE_THRESHOLD = 900_000;
export const TERM_GRANDE = 24;
export const TERM_INTRO = 6;

export const TERM = 3;
export const TERM_PAGO = 3;
export const MIN_AMOUNT = 0;
export const ANNUAL_INTEREST_RATE = 43.03;
export const GUARANTEE_RATE = 13.01;

//BR
export const DEFAULT_TERM = 3;
export const DOWNPAYMENTS_TERM = 4;

/**
 *
 * HTTP
 *
 */

export const ORIGINATIONS_SERVER_STATUS = [-1, 400, 404, 500];
export const EMBEDDED_ONBOARDING_WIDGET_PATH = '/onboarding-widget';

export const CO_PUBLIC_API_URL = 'https://publicapi.addi.com';
export const CO_PUBLIC_API_URL_SANDBOX = 'https://publicapi-sandbox.addi.com';
export const CO_PUBLIC_API_URL_STG = 'https://publicapi.addi-staging.com';
export const CO_EMBEDDED_BASE_URL = 'https://embedded.addi.com';
export const CO_EMBEDDED_BASE_URL_SANDBOX = 'https://embedded-sandbox.addi.com';
export const CO_EMBEDDED_BASE_URL_STG = 'https://embedded.addi-staging.com';
export const CO_EMBEDDED_LOCAL_URL = 'http://localhost:8000';
export const CO_PREAPPROVAL_URL = 'https://preapproval.addi.com';
export const CO_PREAPPROVAL_URL_SANDBOX =
  'https://preapproval-sandbox.addi.com';
export const CO_PREAPPROVAL_URL_STG = 'https://preapproval.addi-staging.com';
export const CO_PREAPPROVAL_URL_LOCAL = 'http://localhost:3008';
export const CO_CHANNELS_PUBLIC_API = 'https://channels-public-api.addi.com';
export const CO_CHANNELS_PUBLIC_API_SANDBOX =
  'https://channels-public-api-sandbox.addi.com';
export const CO_CHANNELS_PUBLIC_API_STG =
  'https://channels-public-api.addi-staging.com';
export const CO_ORIGINATIONS_URL = 'https://originations.addi.com';
export const CO_ORIGINATIONS_URL_LOCAL = 'http://127.0.0.1:3004';
export const CO_ORIGINATIONS_URL_SANDBOX =
  'https://originations-sandbox.addi.com';
export const CO_ORIGINATIONS_URL_STG = 'https://originations.addi-staging.com';
export const CO_HEALTH_CHECK_URL = 'https://stores-health.addi.com/healthcheck';

export const BR_PUBLIC_API_URL = 'https://public.addi.com.br';
export const BR_PUBLIC_API_URL_SANDBOX = 'https://public-sandbox.addi.com.br';
export const BR_PUBLIC_API_URL_STG = 'https://public.addi-staging-br.com';
export const BR_EMBEDDED_BASE_URL = 'https://embedded.addi.com.br';
export const BR_EMBEDDED_LOCAL_URL = 'http://localhost:8000';
export const BR_EMBEDDED_BASE_URL_SANDBOX =
  'https://embedded-sandbox.addi.com.br';
export const BR_EMBEDDED_BASE_URL_STG = 'https://embedded.addi-staging-br.com';
export const BR_CHANNELS_PUBLIC_API = 'https://channels-public-api.addi.com.br';
export const BR_CHANNELS_PUBLIC_API_SANDBOX =
  'https://channels-public-api-sandbox.addi.com.br';
export const BR_CHANNELS_PUBLIC_API_STG =
  'https://channels-public-api.addi-staging-br.com';
export const BR_ORIGINATIONS_URL = 'https://originations.addi.com.br';
export const BR_ORIGINATIONS_URL_LOCAL = 'http://127.0.0.1:3004';
export const BR_ORIGINATIONS_URL_SANDBOX =
  'https://originations-sandbox.addi.com.br';
export const BR_ORIGINATIONS_URL_STG =
  'https://originations.addi-staging-br.com';

export const SANDBOX_TEST_ENVIRONMENT = ['0.0.0.0', 'dummy-sandbox.addi.com'];

export const STAGING_TEST_ENVIRONMENT = [
  'dummy.addi-staging.com',
  'dummy.addi-staging-br.com',
  'wordpress.addi-staging.com',
  'addi.myvtex.com',
];

export const LOCAL_TEST_ENVIRONMENT = [
  '0.0.0.0',
  '127.0.0.1',
  '192.168.1.2',
  'localhost',
];

/***
 *
 * Others
 *
 */
export const IMG_S3_URL =
  'https://s3.amazonaws.com/widgets.addi.com/1x1-00000000.png';
export const IMG_LOGO_SVG_WHITE =
  'https://statics.addi.com/assets/addi-logo-white.svg';
export const IMG_LOGO_ADDI_FLASH =
  'https://statics.addi.com/addi-flash/ADDI_FLASH.svg';
export const IMG_LOGO_LINEAL_DEFAULT =
  'https://statics.addi.com/assets/addi-icon-lineal.png';
export const IMG_LOGO_LINEAL_WEPINK =
  'https://statics.addi.com/assets/addi-icon-lineal-rose.svg';
export const IMG_LOGO_DEFAULT = 'https://statics.addi.com/assets/addi-icon.png';
export const IMG_LOGO_WEPINK =
  'https://statics.addi.com/assets/addi-logo-background-rose.svg';
export const ASSET_ADDI_LOGO_SVG_ROSE_URL =
  'https://statics.addi.com/assets/addi-logo-rose.svg';
export const ALLY_MIN_AMOUNT = 50000;
export const MAX_PREAPPROVAL_AMOUNT = 600000;
export const DEFAULT_WIDGET_VERSION = 'ADDI_TEMPLATE_FLEX';
export const QUERY_PARAM_TO_PREAPPROVAL = 'addi_preapproval';
